import { render, staticRenderFns } from "./sponsorship-packages-list.vue?vue&type=template&id=58c146e8"
import script from "./sponsorship-packages-list.vue?vue&type=script&lang=js"
export * from "./sponsorship-packages-list.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports